import {
    MILITARY_VARIANT,
    STC_VARIANT,
    collection,
    isMilitaryEnabled,
    parentTypeFor,
} from "../_variants/index.js";
import {
    addDQN,
    cancelDQN,
    editDQN,
    linkDQN,
    signoffDQN,
    unlinkDQN
} from "./actions";

import store from "../../../store";

function warning(key) {
    let item = store.state[key];
    if (!item || item.Cancelled === true) return false;

    let warningMessage = "";
    if (item?.Signedoff === false) {
        warningMessage = warningMessage += `${item.Number} is not signedoff.<br>`;
    }
    return warningMessage === "" ? false : warningMessage;
};

const cellClassRules = {
    "text-orange font-bold": params => {
        return warning(params.data);
    }
};

const headers = [{
    "headerName": "Number",
    "field": "Number",
    cellClassRules
}, {
    "headerName": "Comment",
    "field": "Comment",
    cellClassRules
}, {
    "headerName": "Resolved",
    "field": "Signedoff",
    "type": "bool",
    cellClassRules
}, {
    "headerName": "Parent",
    "field": "Parent",
    cellClassRules
}, {
    "headerName": "Reason",
    "field": "Reason",
    cellClassRules
}];

const ADDABLE_PARENT_TYPES = ["DesignChanges", "FlightConditions", "Repairs", "MilitaryDesignChanges", "MilitaryFlightConditions", "MilitaryRepairs"];

/**
 * Build the attachable-table descriptor for the DQN register that matches
 * the supplied variant.
 *
 * @param {import("../_variants/index.js").Variant} variant
 */
export const makeDQNAttachable = (variant) => {
    const isMilitary = variant.key === "military";
    const labelSingular = isMilitary ? "Military DQN" : "DQN";
    const labelPlural = isMilitary ? "Military DQNs" : "DQNs";
    const dqnParentType = parentTypeFor(variant, "DQNs");
    const dqnCollection = collection(variant, "DQNs");

    const actions = [{
        "label": `Add ${labelSingular}`,
        "action": addDQN,
        show({ meta }) {
            return [ADDABLE_PARENT_TYPES.includes(meta?.ParentType), `${labelPlural} cannot be added here, they must be linked.`]
        }
    }, {
        "label": `Link ${labelSingular}`,
        "action": linkDQN
    }];

    const rowActions = [{
        "label": `View ${labelSingular}`,
        action({ router, rowItem }) {
            router.push(`/Database/${dqnParentType}/${rowItem.ID}`)
        }
    }, {
        "label": `Update ${labelSingular}`,
        "break": true,
        "action": editDQN,
        show({ meta }) {
            return [ADDABLE_PARENT_TYPES.includes(meta?.ParentType), "Can only be edited whilst in the parent"]
        }
    }, {
        "label": `Signoff ${labelSingular}`,
        "action": signoffDQN
    }, {
        "label": `Unlink ${labelSingular}`,
        "break": true,
        "action": unlinkDQN
    }, {
        "label": `Cancel ${labelSingular}`,
        "break": true,
        "action": cancelDQN,
        "class": "text-red"
    }];

    return {
        "label": labelPlural,
        "key": dqnParentType,
        "location": `${dqnCollection}/`,
        actions,
        rowActions,
        headers,
        warn({ items }) {
            let warningMessage = items.map(warning).filter(i => i !== false).join("<br>");
            return [warningMessage !== "", warningMessage];
        }
    };
};

export const dqnAttachable = makeDQNAttachable(STC_VARIANT);
export const militaryDQNAttachable = isMilitaryEnabled() ? makeDQNAttachable(MILITARY_VARIANT) : null;

export default dqnAttachable;
